/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CardContainerV2 } from '../../PeopleGridViewV2/styles';
import _ from 'lodash';
import Waiting from '../../Waiting';
import { ImageUrl } from "../../../utils/constants";
import { Container, NoData, Backdrop, GridCard, NoBuddy } from './styles';
const RemoveBuddyPopup = React.lazy(() => import('./removeBuddyPopup'));
import { withTranslation } from 'react-i18next';
import CommonButton from '../../common/CommonButton/CommonButton';
import { fetchApi } from '../../../utils/methods';
import { ConnectedFriend } from '../../../redux/constants/apiConstants';
import { UserButton } from '../../EngagementSection/styles';
import { NextSolidIcon, PriviousSolidIcon } from '../../../utils/icons';

class MyBuddies extends Component {
  constructor() {
    super();
    this.state = {
      showRemoveBuddy: false,
      popupType: "buddies",
      name: null,
      friendId: null,
      showRemoveButton: false,
      removeButtonId: null,
      userId: null,
      initiativeId: null,
      initiativeName: null,
      connections: [],
      loading: true,
      pageNo: 1,
      total: 0
    };
  }

  componentDidMount() {
    this.fetchConnections();
  }

  fetchConnections = async () => {
    try {
      this.setState({ loading: true });
      const { pageNo } = this.state;
      const payload = {
        page_no: pageNo,
        limit: 24,
        name: "",
        interest_ids: [],
        department_ids: [],
        city_state_ids: []
      };

      const response = await fetchApi(ConnectedFriend, 'POST', payload);

      if (response && response.status === 'success' && response.data) {
        const connections = response.data.connections || response.data || [];
        const total = response.data.total || 0;
        const transformedConnections = this.transformConnectionsData(connections);
        this.setState({
          connections: transformedConnections,
          total: total,
          loading: false
        });
      } else {
        this.setState({ connections: [], total: 0, loading: false });
      }
    } catch (error) {
      window.console.error('Error fetching connections:', error);
      this.setState({ connections: [], total: 0, loading: false });
    }
  };

  transformConnectionsData = (connections) => {
    if (!Array.isArray(connections)) return [];
    
    return connections.map((item) => {
      const friend = item.friend || item.friend_details || item.user || item;
      return {
        friend_id: item.friend_id || friend.uid || friend.id,
        fullname: friend.fullname || friend.full_name || friend.name || '',
        profile_image: friend.profile_image || '',
        department: friend.department || '',
        is_champion: friend.is_champion || 0,
        interests: friend.interests || friend.wellness_interests || [],
        mutual_friends_details: item.mutual_friends_details || []
      };
    });
  };

  setPagination = (page) => {
    this.setState({ pageNo: page }, () => {
      this.fetchConnections();
      window.scrollTo(0, 0);
    });
  };

  getPaginationCircle = () => {
    const { pageNo, total } = this.state;
    const totalPages = Math.ceil(total / 24);
    let circleButton = [];
    const maxButtons = 6;
    let startPage = Math.max(1, pageNo - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);
    
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      circleButton.push(
        <UserButton
          key={i}
          width="30px"
          height="34px"
          Align={1}
          marginLeft="5px"
          fontSize="14px"
          bgColor={i === pageNo ? "#DA6C74" : "#f8f8f8"}
          color={i === pageNo ? "#fff" : "#DA6C74"}
          capitalize={1}
          onClick={() => this.setPagination(i)}
        >
          {i}
        </UserButton>
      );
    }
    return circleButton;
  };

  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name
    });
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null
    });
  };

  fallBack = (e) => {
    e.target.src = '/public/images/default.png';
  };

  openCloseRemoveBuddyPopup = (name, id) => {
    this.setState({
      showRemoveBuddy: !this.state.showRemoveBuddy,
      name: name,
      friendId: id,
      showRemoveButton: false
    });
  };

  showRemoveButton = (id) => {
    this.setState({
      showRemoveButton: !this.state.showRemoveButton,
      removeButtonId: id
    });
  };

  closeRemoveBuddyPopup = (shouldRefresh = false) => {
    this.setState({
      showRemoveBuddy: !this.state.showRemoveBuddy,
      name: null,
      friendId: null
    });
    if (shouldRefresh) {
      this.fetchConnections();
    }
  };


  hideRemoveButton = () => {
    this.setState({
      showRemoveButton: false,
      removeButtonId: null
    });
  };

  render() {
    const { t, history, user } = this.props;
    const { showRemoveBuddy, popupType, friendId, name, showRemoveButton, removeButtonId, userId, initiativeId, initiativeName, connections, loading, pageNo, total } = this.state;
    
    const totalPages = Math.ceil(total / 24);

    if (loading) {
      return <Waiting />;
    }

    return (
      !_.isEmpty(connections) ?
        <>
          <Container>
            {showRemoveButton && <Backdrop onClick={this.hideRemoveButton} />}
            {connections.map((friend, index) => (
              <CardContainerV2 key={index} marginRight={(index + 1) % 4 === 0 ? "0px" : "25px"}>
                <div style={{ position: 'relative' }}>
                  <GridCard>
                    <div className="wellness-champion">
                      {friend.is_champion ? <div>{t("Wellness Champion")}</div> : ""}
                    </div>
                    
                    <div style={{ 
                      position: 'absolute', 
                      top: '16px', 
                      right: '16px', 
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255,255,255,0.9)',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      zIndex: 10
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.showRemoveButton(friend.friend_id);
                    }}>
                      <div style={{
                        width: '4px',
                        height: '4px',
                        backgroundColor: '#DA6C74',
                        borderRadius: '50%',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '-6px',
                          left: '0',
                          width: '4px',
                          height: '4px',
                          backgroundColor: '#DA6C74',
                          borderRadius: '50%'
                        }}></div>
                        <div style={{
                          position: 'absolute',
                          top: '6px',
                          left: '0',
                          width: '4px',
                          height: '4px',
                          backgroundColor: '#DA6C74',
                          borderRadius: '50%'
                        }}></div>
                      </div>
                    </div>

                    {showRemoveButton && removeButtonId === friend.friend_id && (
                      <div style={{
                        position: 'absolute',
                        top: '40px',
                        right: '10px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        zIndex: 1001,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        minWidth: '120px',
                        fontSize: '14px',
                        color: '#333'
                      }}>
                        <div 
                          onClick={(e) => {
                            e.stopPropagation();
                            this.openCloseRemoveBuddyPopup(friend.fullname, friend.friend_id);
                          }}
                          style={{ 
                            padding: '4px 0',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                          {t("Remove Buddy")}
                        </div>
                      </div>
                    )}

                    <div className="profile">
                      <div>
                        <img onError={this.fallBack} src={`${ImageUrl}/${friend.profile_image}`} />
                      </div>
                    </div>

                    <div className="name">
                      {t(friend.fullname)}
                    </div>
                    {friend.department ? 
                      <div className="department">{t(friend.department)}</div> :
                      <div className="no-department">NA</div>
                    }
                    
                    <div className="wellness-card">
                      {friend.interests && friend.interests.map((Wellness, idx) => (
                        idx < 5 &&
                        <div key={idx} onMouseEnter={() => this.onEnterMouse(friend.friend_id, Wellness.interest_id, Wellness.interest_name)} onMouseLeave={() => this.onLeaveMouse()}>
                          <img src={`${ImageUrl}/${Wellness.interest_icon}`} />
                          {userId === friend.friend_id && initiativeId === Wellness.interest_id &&
                            <div className="hover-card">
                              <div>{t(initiativeName)}</div>
                            </div>}
                        </div>
                      ))}
                    </div>
                    
                    <div className="mutual-buddies">
                      {friend.mutual_friends_details && friend.mutual_friends_details.length > 0 ?
                        <div>
                          <div className="text">{t("Mutual")}</div>
                          <div className="profile-image-card">
                            {friend.mutual_friends_details.map((mutual, idx) =>
                              idx < 2 &&
                              <img onError={this.fallBack} src={`${ImageUrl}/${mutual.profile_image}`} key={idx} />
                            )}
                            {friend.mutual_friends_details.length > 2 &&
                              <div className="count">{friend.mutual_friends_details.length - 2}+</div>}
                          </div>
                        </div> :
                        <div><div className="no-text">NA</div></div>
                      }
                    </div>
                  </GridCard>
                </div>
              </CardContainerV2>
            ))}
            {showRemoveBuddy && <RemoveBuddyPopup showPopup={showRemoveBuddy} onHide={this.closeRemoveBuddyPopup} popupType={popupType} friendId={friendId} name={name} />}
          </Container>
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '5px' }}>
              {pageNo > 1 && (
                <UserButton width="30px" height="34px" Align={1} fontSize="14px" capitalize={1} onClick={() => this.setPagination(pageNo - 1)}>
                  <PriviousSolidIcon />
                </UserButton>
              )}
              {this.getPaginationCircle()}
              {pageNo < totalPages && (
                <UserButton width="30px" height="34px" Align={1} marginLeft="5px" fontSize="14px" capitalize={1} onClick={() => this.setPagination(pageNo + 1)}>
                  <NextSolidIcon />
                </UserButton>
              )}
            </div>
          )}
        </>
        :
        <NoBuddy>
          {history && history.location.pathname === '/profile' && <div className='greyCircle'></div>}
          {history && history.location.pathname === '/profile' && <div className='nobuddyInfo'>{t("Hey")} <b>{user.fname}</b>, {t("You don't Have any Buddy In your Community")} <br/> {t("lets Grow Your communityConnect with like minded People You May Love to connect.")}</div>}
          {history && history.location.pathname === '/profile' && <button className='goTo-Community' onClick={() => history.push('/community')}>{t("Go to Community")}</button>}
        </NoBuddy>
    );
  }
}

MyBuddies.propTypes = {
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  user: PropTypes.object
};

export default withTranslation()(MyBuddies);
